import { TransactionHistoryCSSStyleImpl } from './transactionhistorylistcss';
import { UIComponentState, UIDataModel, UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { TransactionHistoryViewImpl } from './transactionhistorylistview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { TransactionHistoryDto } from '../../../../core/dto/transactionhistory/transactionhistorydto';
import { TransactionHistoryAPIModelImpl, TransactionHistoryAPIModel } from './transactionhistoryapimodel';
import { CRBTUIComponentProps, CRBTUIComponent } from '../crbt/crbtuicomponent';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';


export interface TransactionHistoryComponentProps extends CRBTUIComponentProps
{
  
}
export interface TransactionHistoryComponentState extends UIComponentState
{
   
    packName: any;
}
export class TransactionHistoryComponent extends CRBTUIComponent<TransactionHistoryComponentProps, TransactionHistoryComponentState>
{
    constructor(props: TransactionHistoryComponentProps)
    {
        super(props);
        this.state = {packName: ""};
    }

  
    componentDidMount()
    {
        (this.getView() as TransactionHistoryViewImpl).showLoader();
      
   
        this.getAPIModel().getTransactionHistory();
    }
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new TransactionHistoryViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new TransactionHistoryCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new TransactionHistoryAPIModelImpl(applicationContext, apiModelHandler);
    }

   
    getAPIModel(): TransactionHistoryAPIModel
    {
        return (super.getAPIModel() as TransactionHistoryAPIModel);
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
       
        (this.getView() as TransactionHistoryViewImpl).dismissLoader();
    //    if(this.props.context.getUserContext().getPackName() === undefined)
    //    {
    //        console.log("----tigerun");
    //     (this.getView() as TransactionHistoryViewImpl).showInactiveSubscriberPopup();
    //    }
    //    else{
    //     console.log("----tigersub");
        if((data as TransactionHistoryDto[]).length === 0)
        {
            (this.getView() as TransactionHistoryViewImpl).showPopup(this.getContext().getResources().getString(Strings.no_history_at_the_moment),  AlertType.ERROR,
                this.getContext().getResources().getString(Strings.ok));
        }
        else
        {
            (this.getView() as TransactionHistoryViewImpl).setListOfDatas(data as TransactionHistoryDto[]);
        }
    this.forceUpdateComponent();
    window.scroll(0, 0);   
       
    }
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as TransactionHistoryViewImpl).dismissLoader();
        // if(this.props.context.getUserContext().getPackName() === undefined)
        // {
        //     console.log("----tigerun");
        //  (this.getView() as TransactionHistoryViewImpl).showInactiveSubscriberPopup();
        // }
        // else
        // {
        (this.getView() as TransactionHistoryViewImpl).showPopup(this.getContext().getResources().getString(Strings.no_history_at_the_moment),  AlertType.ERROR,
            this.getContext().getResources().getString(Strings.ok));
        
        window.scroll(0, 0);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/transactionhistory/transactionhistorylistcomponent.tsx